import React from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';

const SEO = ({ 
  title, 
  description,
  keywords,
  canonical,
  ogImage 
}) => {
  const defaultTitle = "PaysFor | Abattage d'arbres et élagage à Québec – Service professionnel";
  const defaultDescription = "PaysFor est une entreprise spécialisée en abattage d'arbres et élagage à Québec. Services professionnels et sécuritaires pour résidentiel et commercial dans la Capitale-Nationale. Soumission rapide.";
  const defaultKeywords = "abattage d'arbres Québec, élagage Québec, élagueur Québec, coupe d'arbre Québec, arboriste Québec, taille d'arbres Québec, émondage Québec, services arboricoles Capitale-Nationale";
  const siteUrl = "https://paysfor.ca";
  const defaultImage = `${siteUrl}/android-chrome-512x512.png`;

  const seoTitle = title || defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoImage = ogImage || defaultImage;
  const seoCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <link rel="canonical" href={seoCanonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:url" content={seoCanonical} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
    </Helmet>
  );
};

export default SEO;
